<template>
    <span>
        <slot name="trigger" :toggle="toggle"></slot>

        <transition
            enter-active-class="ease-out duration-200"
            enter-from-class="opacity-0"
            enter-to-class="opacity-100"
            leave-active-class="duration-200 ease-in"
            leave-from-class="opacity-100"
            leave-to-class="opacity-0"
        >
            <div class="fixed z-10 inset-0 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true" v-if="active" @click="toggle">
                <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                    <div class="fixed inset-0 bg-gray-500/75 bg-opacity-75 transition-opacity" aria-hidden="true"></div>

                    <!-- This element is to trick the browser into centering the modal contents. -->
                    <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

                    <div class="relative inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full" @click.stop="">
                        <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                            <div class="sm:flex sm:items-start">
                                <div :class="`mx-auto shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-${colour}-100 sm:mx-0 sm:h-10 sm:w-10`">
                                    <svg v-if="icon === 'exclamation'" :class="`h-6 w-6 text-${colour}-600`" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                                    </svg>
                                    <svg v-if="icon === 'info'" :class="`h-6 w-6 text-${colour}-600`" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"></path>
                                    </svg>
                                </div>
                                <div class="mt-3 text-center sm:mt-2 sm:ml-4 sm:text-left">
                                    <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-title">{{ title }}</h3>
                                    <div class="mt-2 whitespace-normal">
                                        <p class="text-sm text-gray-500"><slot />{{ text }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                            <a type="button" v-if="url" :href="url" :class="`w-full inline-flex justify-center rounded-md border border-transparent shadow-xs px-4 py-2 bg-${colour}-600 text-base font-medium text-white hover:bg-${colour}-700 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-${colour}-500 sm:ml-3 sm:w-auto sm:text-sm`">{{ buttonText }}</a>
                            <a type="button" v-if="callback" href="#" @click.prevent="triggerCallback" :class="`w-full inline-flex justify-center rounded-md border border-transparent shadow-xs px-4 py-2 bg-${colour}-600 text-base font-medium text-white hover:bg-${colour}-700 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-${colour}-500 sm:ml-3 sm:w-auto sm:text-sm`">{{ buttonText }}</a>
                            <button @click.prevent="toggle" type="button" :class="`mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-xs px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-hidden focus:ring-2 focus:ring-offset-2 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm`">{{ cancelButtonText }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </span>
</template>

<script>
export default {
    name: "Alert",
    props: {
        title: String,
        text: String,
        icon: {
            type: String,
            default: 'exclamation'
        },
        buttonText: {
            type: String,
            default: "Confirm"
        },
        cancelButtonText: {
            type: String,
            default: "Cancel"
        },
        url: String,
        callback: Function,
    },
    computed: {
        colour() {
            // text-blue-100
            // text-blue-500
            // text-blue-600
            // text-blue-700
            // hover:bg-blue-700
            // focus:ring-blue-500
            // bg-blue-600
            // hover:bg-blue-700

            // text-red-100
            // text-red-500
            // text-red-600
            // text-red-700
            // hover:bg-red-700
            // focus:ring-red-500
            // bg-red-600
            // hover:bg-red-700

            if (this.icon === 'info') {
                return 'blue';
            }

            if (this.icon === 'info') {
                return 'blue';
            }

            return 'red';
        }
    },
    data() {
        return {
            active: false,
        };
    },
    methods: {
        toggle() {
            this.active = ! this.active;
        },

        triggerCallback() {
            this.toggle();
            this.callback();
        },
    }
}
</script>

<style scoped>

</style>
